<!-- <mat-card class="welcome-header">
  <mat-card-title> Welcome! </mat-card-title>
  <mat-card-content>
    You can use Part Numbers, Descriptions, Industry Terms, or our categories to get your search started. If you have your own part
    numbers loaded with us, you can also search using those.
  </mat-card-content>
</mat-card> -->

<ideal-one-column-layout>
  <ideal-product-listing-layout [floatHeader]="floatHeader()">
    <form header [formGroup]="form" #searchForm="ngForm">
      <div class="search-term-container">
        <ideal-label-frame label="Search Terms">
          <ideal-search-term-bar [query]="queryAst()" (removed)="removedCondition($event, searchForm)"></ideal-search-term-bar>
        </ideal-label-frame>
      </div>
      @if (!forceGridView()) {
        <div class="view-container">
          <mat-button-toggle-group [value]="view()" (valueChange)="setView($event)" aria-label="View mode">
            <mat-button-toggle value="grid"><mat-icon>grid_view</mat-icon></mat-button-toggle>
            <mat-button-toggle value="list"><mat-icon>list</mat-icon></mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      }
    </form>

    @if (error()) {
      <ideal-error [error]="error()" />
    } @else {
      @if (hasQuery()) {
        @if (!isSearching() && searchResults().length === 0) {
          <ideal-label-frame label="No Results Found"> <p>Try adjusting your search terms.</p> </ideal-label-frame>`
        } @else {
          <ideal-product-result-list [ids]="resultIds()" [view]="effectiveView()"></ideal-product-result-list>
          <ideal-load-more [mode]="loadMoreMode()" (loadMore)="loadMore()" [loading]="isSearching()" [disabled]="!hasMore()" />
        }
      }
    }
  </ideal-product-listing-layout>
</ideal-one-column-layout>
